import AxiosJob from '@/services/api/job/axios_job'

export default {
  createPool: (data) => {
    return AxiosJob.post('pool', data)
  },

  updatePool: (poolId, data) => {
    return AxiosJob.put(`pool/${poolId}`, data)
  },

  getAllPools: (params) => {
     return AxiosJob.get('pool', { params })
  },

  getPool: (poolId) => {
    return AxiosJob.get(`pool/${poolId}`)
  },

  deletePool: (poolId) => {
    return AxiosJob.delete(`pool/${poolId}`)
  }
}
